export default __webpack_public_path__ + "static/media/EM0070.34I-19683_-24635_0.0c7e6644.jpg";